export const SET_WEBSITE_KEY = 'CONFIG::SET_WEBSITE_KEY';
export const SET_DOMAIN_TOKEN = 'CONFIG::SET_DOMAIN_TOKEN';
export const SET_API_URL = 'CONFIG::SET_API_URL';
export const SET_PUSHER_INFO = 'CONFIG::SET_PUSHER_INFO';
export const SET_PM_CONFIG = 'CONFIG::SET_PM_CONFIG';
export const SET_BRANDING_DISABLED = 'CONFIG::SET_BRANDING_DISABLED';

export const setWebsiteKey = (websiteKey) => ({
    type: SET_WEBSITE_KEY,
    websiteKey
});

export const setDomainToken = (domainToken) => ({
    type: SET_DOMAIN_TOKEN,
    domainToken
});

export const setApiUrl = (apiUrl) => ({
    type: SET_API_URL,
    apiUrl
});

export const setPusherInfo = (pusherInfo) => ({
    type: SET_PUSHER_INFO,
    pusherInfo
});

export const setPMConfig = ({desktopLimit = 3, mobileLimit = 1}) => ({
    type: SET_PM_CONFIG,
    config: {
        desktopLimit,
        mobileLimit
    }
});

export const setBrandingDisabled = (brandingDisabled) => ({
    type: SET_BRANDING_DISABLED,
    brandingDisabled,
});
